var _g, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCirculos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 720,
    height: 666,
    viewBox: "0 0 720 666",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_387_1013)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 373.897,
    cy: 374.103,
    r: 373.897,
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373.897,
    cy: 374.103,
    r: 373.897,
    fill: "url(#paint0_linear_387_1013)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373.897,
    cy: 374.103,
    r: 372.897,
    stroke: "url(#paint1_linear_387_1013)",
    strokeWidth: 2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_387_1013)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 373.897,
    cy: 374.103,
    r: 295.754,
    fill: "white",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373.897,
    cy: 374.103,
    r: 295.754,
    fill: "url(#paint2_linear_387_1013)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373.897,
    cy: 374.103,
    r: 294.754,
    stroke: "url(#paint3_linear_387_1013)",
    strokeWidth: 2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_387_1013)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 373.897,
    cy: 374.103,
    r: 212.666,
    fill: "white",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373.897,
    cy: 374.103,
    r: 212.666,
    fill: "url(#paint4_linear_387_1013)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373.897,
    cy: 374.103,
    r: 211.666,
    stroke: "url(#paint5_linear_387_1013)",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_387_1013",
    x: -10,
    y: -9.79395,
    width: 767.794,
    height: 767.794,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_387_1013"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_387_1013",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_387_1013",
    x: 68.1426,
    y: 68.3483,
    width: 611.509,
    height: 611.509,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_387_1013"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_387_1013",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_387_1013",
    x: 151.231,
    y: 151.437,
    width: 445.333,
    height: 445.333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_387_1013"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_387_1013",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_387_1013",
    x1: 373.897,
    y1: 0.206055,
    x2: 373.897,
    y2: 748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_387_1013",
    x1: 138.276,
    y1: 86.49,
    x2: 613.39,
    y2: 668.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.180689,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_387_1013",
    x1: 373.897,
    y1: 78.3483,
    x2: 373.897,
    y2: 669.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_387_1013",
    x1: 187.519,
    y1: 146.599,
    x2: 563.337,
    y2: 607.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.180689,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_387_1013",
    x1: 373.897,
    y1: 161.437,
    x2: 373.897,
    y2: 586.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_387_1013",
    x1: 239.879,
    y1: 210.514,
    x2: 510.117,
    y2: 541.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.180689,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirculos);
export default __webpack_public_path__ + "static/media/Circulos.c417744314024289fe54ba8ac9315055.svg";
export { ForwardRef as ReactComponent };